export function shouldRenderButtonSpinner(loading, asChild) {
    return Boolean(loading) && !asChild;
}
